import { api } from '../utils/api';
import type { User } from '../types/@types/user';

export interface CreateUserPayload {
  name: string;
  email: string;
  password: string;
  role: 'admin' | 'cashier' | 'kitchen';
  phone?: string;
  status?: 'active' | 'inactive';
  profile_id?: number;
}

export interface UpdateUserPayload {
  name?: string;
  email?: string;
  role?: 'admin' | 'cashier' | 'kitchen';
  phone?: string;
  status?: 'active' | 'inactive';
  profile_id?: number | null;
}

export async function listUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>('/users');
  return data;
}

export async function createUser(payload: CreateUserPayload): Promise<User> {
  const { data } = await api.post<User>('/users', payload);
  return data;
}

export async function updateUser(id: string | number, payload: UpdateUserPayload): Promise<User> {
  const { data } = await api.put<User>(`/users/${id}`, payload);
  return data;
}

export async function deleteUser(id: string | number): Promise<void> {
  await api.delete(`/users/${id}`);
}

export async function changeUserPassword(id: string | number, password: string): Promise<void> {
  await api.post(`/users/${id}/change-password`, { password });
}
